import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => {
  const { primary, secondary } = theme.palette;

  return {
    modal: {
      "& .MuiPaper-root": {
        width: 343,
        borderRadius: 6,
        boxShadow: "0px 0px 12px 0px rgba(0, 0, 0, 0.4)"
      }
    },
    modalHeader: {
      padding: "16px 24px 14px",
      position: "relative",
      borderBottom: `1px solid ${primary.light}`,
      "& .MuiTypography-root": {
        lineHeight: "normal"
      }
    },
    modalTitle: {
      fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
      fontSize: 20
    },
    modalSubTitle: {
      display: "flex",
      alignItems: "center",
      fontSize: 16,
      color: primary.dark
    },
    horseIcon: {
      width: 16,
      marginRight: 8
    },
    modalContent: {
      padding: "16px 24px"
    },
    horseDetailsLink: {
      display: "flex",
      width: "100%",
      height: 40,
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: secondary.dark,
      borderRadius: 3,
      color: theme.palette.common.white,
      textTransform: "uppercase",
      margin: "14px 0 18px",
      cursor: "pointer",
      "&:hover": {
        backgroundColor: "#7ad8b3"
      }
    },
    modalActions: {
      display: "flex",
      padding: 0,
      borderTop: `1px solid ${primary.light}`,
      "&.MuiDialogActions-spacing > :not(:first-child)": {
        marginLeft: 0
      }
    },
    actionButton: {
      display: "flex",
      flexGrow: 1,
      justifyContent: "center",
      alignItems: "center",
      height: 66,
      fontSize: 16,
      padding: 0,
      width: "50%",
      borderRadius: 0,
      color: primary.main,
      "&:last-child": {
        borderLeft: `1px solid ${primary.light}`
      }
    },
    closeButton: {
      position: "absolute",
      right: 3,
      top: 3
    }
  };
});
